var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSentinel = function SvgSentinel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C7784C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sentinel_svg__sentinel_svg__clip0_11127_31040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 6.167l.069.004.034.004.036.008.064.02a.581.581 0 01.127.065l.06.048.15.127a6.417 6.417 0 004.193 1.48l.2-.006a.583.583 0 01.586.418 7.583 7.583 0 01-5.372 9.48.583.583 0 01-.292 0 7.581 7.581 0 01-5.372-9.48.583.583 0 01.586-.418 6.417 6.417 0 004.393-1.474l.153-.131.056-.044a.58.58 0 01.127-.065l.065-.02a.568.568 0 01.07-.012l.067-.005zm2.164 4.254a.584.584 0 00-.825 0l-1.921 1.92-.755-.754-.054-.048a.583.583 0 00-.77.873l1.166 1.167.055.048a.583.583 0 00.77-.048l2.333-2.333.049-.055a.583.583 0 00-.049-.77h.001z",
    fill: "#F7FBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sentinel_svg__sentinel_svg__clip0_11127_31040"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgSentinel;